<template>
  <div class="user">
    <!-- 顶部搜索区域 -->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="岗位名称">
          <el-input 
            placeholder="请输入岗位名称" 
            v-model="formInline.name"
            style="width: 200px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="岗位职能">
          <el-input 
            placeholder="请输入岗位职能" 
            v-model="formInline.description"
            style="width: 200px;"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">
        添加岗位
      </el-button>
    </div>

    <!-- 岗位列表表格 -->
    <div class="product-content">
      <div class="table-wrap">
        <el-table 
          size="small" 
          :data="tableData" 
          border 
          style="width: 100%" 
          v-loading="loading"
          row-key="ma_position_id"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        >
          <el-table-column prop="name" label="岗位名称" width="200">
            <template slot-scope="scope">
              <div style="display: flex; align-items: center;">
                <span style="margin-left: 10px;">{{ scope.row.name }}</span>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column prop="code" label="岗位编码" width="120">
            <template slot-scope="scope">
              {{ scope.row.code || '-' }}
            </template>
          </el-table-column>
          
          <el-table-column prop="description" label="岗位职能">
            <template slot-scope="scope">
              {{ scope.row.description || '-' }}
            </template>
          </el-table-column>
          
          <el-table-column prop="ma_depart_id" label="所属部门" width="150">
            <template slot-scope="scope">
              {{ scope.row.depart_name || '-' }}
            </template>
          </el-table-column>
          
          <el-table-column prop="is_leader" label="负责人岗" width="100" align="center">
            <template slot-scope="scope">
              <el-tag size="small" :type="scope.row.is_leader === 1 ? 'success' : 'info'">
                {{ scope.row.is_leader === 1 ? '是' : '否' }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column prop="sort" label="排序" width="100" align="center">
            <template slot-scope="scope">
              <el-input-number 
                width="80"
                v-model="scope.row.sort" 
                size="mini" 
                controls-position="right" 
                :min="0" 
                :max="999"
                @change="handleSortChange(scope.row)"
              ></el-input-number>
            </template>
          </el-table-column>
          
          <el-table-column prop="status" label="状态" width="140" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                active-text="启用"
                inactive-text="停用"
                @change="handleStatusChange(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          
          <el-table-column prop="create_time" label="创建时间" width="180">
            <template slot-scope="scope">
              {{ scope.row.create_time }}
            </template>
          </el-table-column>
          
          <el-table-column fixed="right" label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button 
                @click="editClick(scope.row)" 
                type="text" 
                size="small"
                icon="el-icon-edit"
              >编辑</el-button>
              
              <el-button 
                @click="deleteClick(scope.row)" 
                type="text" 
                size="small"
                icon="el-icon-delete"
                style="color: #f56c6c;"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!-- 添加岗位弹窗 -->
    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    
    <!-- 编辑岗位弹窗 -->
    <Edit :open_add="open_edit" :ma_position_id="ma_position_id" v-if="open_edit" @close="closeEdit"></Edit>
  </div>
</template>

<script>
import AfuncApi from '@/api/afunc.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';

export default {
  components: {
    Add,
    Edit,
  },
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 20,
      totalDataNumber: 0,
      curPage: 1,

      open_add: false,
      open_edit: false,
      ma_position_id: 0,
      
      // 搜索表单
      formInline: {
        name: '',
        description: ''
      },
      
      // 部门列表（用于显示部门名称）
      departmentList: []
    };
  },
  created() {
    this.getTableList();
    this.getDepartmentList();
  },
  methods: {
    // 获取部门列表 - 使用通用API
    async getDepartmentList() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_depart',
          action: 'index',
          page: 1,
          list_rows: 1000
        });
        
        if (response.code === 1 && response.data.list) {
          this.departmentList = response.data.list.data || [];
        }
      } catch (error) {
        console.error('获取部门列表失败:', error);
      }
    },
    
    // 获取表格数据 - 使用通用API
    async getTableList() {
      try {
        this.loading = true;
        
        const response = await AfuncApi.call({
          model: 'ma_position',
          action: 'index',
          page: this.curPage,
          list_rows: this.pageSize,
          ...this.formInline
        });
        
        if (response.code === 1 && response.data.list) {
          const positionList = response.data.list.data || [];
          
          // 关联部门名称
          this.tableData = positionList.map(position => {
            const department = this.departmentList.find(
              dept => dept.ma_depart_id === position.ma_depart_id
            );
            return {
              ...position,
              depart_name: department ? department.name : '-'
            };
          });
          
          this.totalDataNumber = response.data.list.total || 0;
        }
      } catch (error) {
        console.error('获取岗位列表失败:', error);
      } finally {
        this.loading = false;
      }
    },
    
    // 搜索
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },
    
    // 重置搜索
    resetSearch() {
      this.formInline = {
        name: '',
        description: ''
      };
      this.curPage = 1;
      this.getTableList();
    },
    
    // 分页
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },
    
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    
    // 添加岗位
    addClick() {
      this.open_add = true;
    },
    
    // 编辑岗位
    editClick(row) {
      this.open_edit = true;
      this.ma_position_id = row.ma_position_id;
    },
    
    // 删除岗位 - 使用通用API
    async deleteClick(row) {
      try {
        await this.$confirm('此操作将删除该岗位, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        const response = await AfuncApi.call({
          model: 'ma_position',
          action: 'del',
          ma_position_id: row.ma_position_id
        });
        
        if (response.code === 1) {
          this.$message.success('删除成功');
          this.getTableList();
        } else {
          this.$message.error(response.msg || '删除失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        }
      }
    },
    
    // 处理排序改变 - 使用通用API
    async handleSortChange(row) {
      try {
        const response = await AfuncApi.call({
          model: 'ma_position',
          action: 'edit',
          ma_position_id: row.ma_position_id,
          sort: row.sort
        });
        
        if (response.code === 1) {
          this.$message.success('排序更新成功');
        } else {
          this.$message.error(response.msg || '更新失败');
        }
      } catch (error) {
        console.error('更新排序失败:', error);
        this.getTableList(); // 重新加载恢复原排序
      }
    },
    
    // 处理状态改变 - 使用通用API
    async handleStatusChange(row) {
      try {
        const response = await AfuncApi.call({
          model: 'ma_position',
          action: 'edit',
          ma_position_id: row.ma_position_id,
          status: row.status
        });
        
        if (response.code === 1) {
          this.$message.success('状态更新成功');
        } else {
          this.$message.error(response.msg || '更新失败');
        }
      } catch (error) {
        console.error('更新状态失败:', error);
        this.getTableList(); // 重新加载恢复原状态
      }
    },
    
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
  }
};
</script>

<style lang="scss" scoped>
.user {
  padding: 20px;
  background: #fff;
  min-height: calc(100vh - 90px);
}

.common-seach-wrap {
  background: #f8f9fa;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  
  .demo-form-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }
}

.common-level-rail {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.product-content {
  .table-wrap {
    margin-bottom: 20px;
    
    .el-table {
      border: 1px solid #ebeef5;
      border-radius: 4px;
      
      ::v-deep .el-table__header-wrapper {
        background: #f8f9fa;
        
        th {
          background: #f8f9fa;
          font-weight: bold;
          color: #333;
        }
      }
      
      ::v-deep .el-table__row {
        &:hover {
          background-color: #f5f7fa;
        }
      }
    }
  }
  
  .pagination {
    display: flex;
    justify-content: center;
    padding: 20px 0;
  }
}

// 表格操作按钮样式
.el-button--text {
  padding: 4px 8px;
  font-size: 12px;
  
  &.el-button--small {
    padding: 5px 10px;
  }
}

// 响应式调整
@media (max-width: 768px) {
  .common-seach-wrap {
    .demo-form-inline {
      flex-direction: column;
      align-items: stretch;
      
      .el-form-item {
        margin-bottom: 10px;
        width: 100%;
        
        .el-input {
          width: 100%;
        }
      }
    }
  }
  
  .product-content {
    .table-wrap {
      overflow-x: auto;
      
      .el-table {
        min-width: 800px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/plus/ma_position/index/index.vue